<template>
  <div class="jinxian" v-if="hasData">
    <div class="return-btn" v-if="btype==='1'">
      <el-button type="success" size="medium" icon="el-icon-arrow-left" @click="goNext()"> 返回 </el-button>
    </div>
    <div class="section1">
      <div class="item1">
        <layout1 :title="''">
          <div class="box">
            <img src="../../../assets/images/bianyaqi.png" alt="" />
            <div class="title"></div>
            <!-- <div class="switch">
                          <p>切换设备</p>
                          <i class="iconfont icon-qiehuan"></i>
                        </div> -->
            <el-select v-model="equipmentCode" @change="changeEquipment" placeholder="切换设备">
              <el-option v-for="item in options" :key="item.equipmentCode" :label="item.localeNumber"
                :value="item.equipmentCode">
              </el-option>
            </el-select>
            <div class="update-time">
              <span>设备状态：</span>
              <span>{{
                equipmentNumber.equipmentStatus | filterOpenType
                }}</span>
            </div>
            <!-- <div class="number">
                          <span>馈线回路总数：</span>
                          <span>{{ equipmentNumber.totalCount }}</span>
                        </div> -->
            <!-- <div class="bottom-box">
                          <div class="top">
                            <div class="left">
                              <span>正常回路：</span>
                              <span>{{ equipmentNumber.normalCount }}</span>
                            </div>
                            <div class="right">
                              <span>异常回路：</span>
                              <span>{{ equipmentNumber.abnormalCount }}</span>
                            </div>
                          </div>
                          <div class="middle">
                            <div
                              class="left"
                              :style="{
                                width:
                                  (equipmentNumber.normalCount /
                                    equipmentNumber.totalCount) *
                                    100 +
                                  '%',
                              }"
                            ></div>
                            <div
                              class="among"
                              :style="{
                                width:
                                  (equipmentNumber.abnormalCount /
                                    equipmentNumber.totalCount) *
                                    100 +
                                  '%',
                              }"
                            ></div>
                            <div
                              class="right"
                              :style="{
                                width:
                                  (equipmentNumber.breakOff / equipmentNumber.totalCount) *
                                    100 +
                                  '%',
                              }"
                            ></div>
                          </div> -->
            <!-- <div class="bottom">
                            <span>断开回路：</span>
                            <span>{{ equipmentNumber.breakOff }}</span>
                          </div> -->
            <!-- </div> -->
          </div>
        </layout1>
      </div>
      <div class="item2">
        <!-- v-if="ifShowTable" -->
        <layout1 :title="'实时数据'" v-if="ifShowTable">
          <div class="box">
            <span class="renew-time">更新时间：{{renewTime}}</span>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="number" label="编号" width="80">
              </el-table-column>
              <el-table-column prop="type" label="数据类型" width="120">
              </el-table-column>
              <el-table-column label="数据详情">
                <template slot-scope="scope">
                  <div class="data-info">
                    <div class="item" v-for="(item, index) in scope.row.info" :key="index">
                      <span>{{ item.subscribeFieldName }}</span>
                      <span>：</span>
                      <span v-if="item.subscribeFieldName==='负载率'">{{ item.value == "-" ? "-" : item.value*100 | getFour
                        }}
                        <span v-if="item.value !== '-'">{{ item.unit }}</span></span>
                      <span v-else-if="item.subscribeFieldName==='已使用次数'">{{ item.value == "" ? "0" : item.value }}
                        {{ item.unit }}</span>
                      <span v-else>{{ item.value == "" ? "0" : item.value | genderMenu }}
                        {{ item.unit }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </layout1>
      </div>
    </div>
    <div class="section2">
      <div class="item1">
        <layout1 :title="'历史数据查询'">
          <div class="box">
            <div class="data-download">
              <div class="block">
                <span class="demonstration">日期：</span>
                <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" :picker-options="expireTimeOption"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
              <img @click="download" v-if="hasData2" src="../../../assets/images/download.png" />
            </div>
            <div class="change-box">
              <div class="item" :class="changeIndex == 0 ? 'active' : ''" @click="changeIndex = 0">
                图表
              </div>
              <div class="item" :class="changeIndex == 1 ? 'active' : ''" @click="changeIndex = 1">
                数据
              </div>
            </div>
            <div class="table">
              <div class="swtich" v-if="changeIndex == 0">
                <div class="item" :class="item.smallType == smallType ? 'active' : ''"
                  v-for="(item, index) in changeLabelList" :key="index" @click="smallType = item.smallType">
                  {{ item.label }}
                </div>
              </div>
              <v-chart v-if="changeIndex == 0 && hasData2" :option="option" ref="chart"></v-chart>
              <div class="show-date" v-if="changeIndex == 1">日期：{{showTime}}</div>
              <div class="table-box" v-if="changeIndex == 1">
                <el-table :data="tableData1" border style="width: 99%" height="420">
                  <!-- <el-table-column prop="time" label="日期" width="120">
                  </el-table-column> -->
                  <el-table-column prop="time" label="时间" width="150">
                  </el-table-column>
                  <el-table-column label="电压(V)" v-if="equipmentType===1">
                    <el-table-column prop="07" label="A相" width="150">
                    </el-table-column>
                    <el-table-column prop="08" label="B相" width="150">
                    </el-table-column>
                    <el-table-column prop="09" label="C相" width="150">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="电压(V)" v-if="equipmentType===2">
                    <el-table-column prop="01" label="A相" width="150">
                    </el-table-column>
                    <el-table-column prop="02" label="B相" width="150">
                    </el-table-column>
                    <el-table-column prop="03" label="C相" width="150">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column prop="11" label="三相电压不平衡度" width="145" v-if="equipmentType===1">
                  </el-table-column>
                  <el-table-column prop="06" label="三相电压不平衡度" width="145" v-if="equipmentType===2">
                  </el-table-column>
                  <el-table-column label="电流(A)">
                    <el-table-column prop="12" label="A相" width="110">
                    </el-table-column>
                    <el-table-column prop="13" label="B相" width="110">
                    </el-table-column>
                    <el-table-column prop="14" label="C相" width="110">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column prop="17" label="三相电流不平衡度" width="145">
                  </el-table-column>
                  <el-table-column label="功率">
                    <el-table-column prop="18" label="有功(kW)" width="110">
                    </el-table-column>
                    <el-table-column prop="22" label="无功(kVar)" width="110">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column prop="calculatePower" label="电量(kWh)" width="155">
                  </el-table-column>
                  <el-table-column label="功率因数">
                    <el-table-column prop="301" label="最低" width="110">
                    </el-table-column>
                    <el-table-column prop="302" label="最高" width="110">
                    </el-table-column>
                    <el-table-column prop="30" label="平均" width="110">
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="image-box" v-if="!hasData2 && changeIndex == 0">
            <img src="../../../assets/images/nodata1.png" alt="" />
          </div>
        </layout1>
      </div>
    </div>
  </div>
  <div class="nodata" v-else>
    <p>抱歉，当前配电室暂无设备</p>
    <img src="../../../assets/images/nodata2.png" alt="" />
  </div>
</template>

<script>
  import layout1 from "../../layout/layout1";
  import ECharts from "vue-echarts";
  export default {
    components: {
      layout1,
      "v-chart": ECharts,
    },
    data () {
      return {
        equipmentType: 2,
        equipmentNumber: {},
        ifShowTable: true,
        // //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
        expireTimeOption: {
          disabledDate (date) {
            return date.getTime() > Date.now();
          },
        },
        tableData: [{
          number: 1,
          type: "电流",
          info: [{
            subscribeFieldName: "A相电压",
            value: "0.00A",
          },
          {
            subscribeFieldName: "B相电压",
            value: "0.00A",
          },
          {
            subscribeFieldName: "C相电压",
            value: "0.00A",
          },
          ],
        },
        {
          number: 2,
          type: "电压",
          info: [{
            subscribeFieldName: "A相电压",
            value: "0.00V",
          },
          {
            subscribeFieldName: "B相电压",
            value: "0.00V",
          },
          {
            subscribeFieldName: "C相电压",
            value: "0.00V",
          },
          ],
        },
        {
          number: 3,
          type: "功率",
          info: [{
            subscribeFieldName: "三相总有功功率",
            value: "0kVar",
          },
          {
            subscribeFieldName: "三相总无功功率",
            value: "0kW",
          },
          ],
        },
        {
          number: 4,
          type: "电量、负载率",
          info: [{
            subscribeFieldName: "总电量",
            value: "0.00",
          },
          {
            subscribeFieldName: "负载率",
            value: "0.00",
          },
          ],
        },
        {
          number: 5,
          type: "变压器温度",
          info: [{
            subscribeFieldName: "A相",
            value: "0.00 ℃",
          },
          {
            subscribeFieldName: "B相",
            value: "0.00 ℃",
          },
          {
            subscribeFieldName: "C相",
            value: "0.00 ℃",
          },
          ],
        },
        {
          number: 6,
          type: "设备开合次数",
          info: [{
            subscribeFieldName: "已使用次数",
            value: "0次",
          },],
        },
        {
          number: 7,
          type: "设备使用时间",
          info: [{
            subscribeFieldName: "使用时间",
            value: "0天",
          },],
        },
        ],
        options: [{
          value: "",
          label: "",
        },],
        equipmentCode: "",
        date: "",
        // swtichList: ["电压", "电流", "功率", "温度", "湿度"],
        // swtichIndex: 0,
        changeIndex: 0, // 0图表,1:表格
        option: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              label: {
                backgroundColor: "#6a7985",
                formatter: function (p) {
                  if (p.axisIndex == 1) {
                    return "";
                  }
                  let str = p.seriesData[0].data[0];
                  let str2 = "";
                  p.seriesData.forEach((i) => {
                    str2 + "<br/>" + i.seriesName + ": " + i.data[1];
                  });
                  return str + str2;
                },
              },
            },
          },
          legend: {
            right: "5%",
            top: "4%",
            data: ["A相电压", "B相电压", "C相电压"],
          },
          color: [
            "rgba(0, 191, 113, 1)",
            "rgba(251, 199, 2, 1)",
            "rgba(20, 108, 224, 1)",
          ],
          grid: {
            left: "1%",
            right: "4%",
            bottom: "3%",
            top: "10%",
            containLabel: true,
          },
          xAxis: [{
            show: false,
            position: "top",
            type: "time",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
          {
            show: true,
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            position: "bottom",
            axisPointer: {
              type: "none",
            },
            data: [
              "0时",
              "1时",
              "2时",
              "3时",
              "4时",
              "5时",
              "6时",
              "7时",
              "8时",
              "9时",
              "10时",
              "11时",
              "12时",
              "13时",
              "14时",
              "15时",
              "16时",
              "17时",
              "18时",
              "19时",
              "20时",
              "21时",
              "22时",
              "23时",
              "24时",
            ],
          },
          ],
          yAxis: {
            type: "value",
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
            },
          },
          series: [{
            name: "A相电压",
            type: "line",
            symbolSize: 0,
            lineStyle: {
              width: 4,
            },
            data: [],
          },
          {
            name: "B相电压",
            type: "line",
            symbolSize: 0,
            lineStyle: {
              width: 4,
            },
            data: [],
          },
          {
            name: "C相电压",
            type: "line",
            symbolSize: 0,
            lineStyle: {
              width: 4,
            },
            data: [],
          },
          ],
        },
        tableData1: [],
        labelList: [],
        smallType: null,
        topicList: [],
        topicList2: [],
        hasData: true,
        hasData2: true,
        showTime: "",
        renewTime: "",
        btype: '',
      };
    },
    created () {
      this.btype = this.$route.query.type;
      this.searchEquipmentByType();
      this.showTime = this.$dateFormat("YYYY年mm月dd日", new Date());
      this.date = this.$dateFormat("YYYY-mm-dd", new Date());
    },
    filters: {
      filterOpenType (v) {
        // alert(v)
        if (v === -1) {
          return "离线";
        } else if (v === 0) {
          return "断开";
        } else if (v === 1) {
          return "闭合";
        } else {
          return "";
        }
      },
    },
    methods: {
      changeEquipment (v) {
        this.topicList.forEach((item) => {
          this.$clearTimeing(item);
        });
        this.equipmentCode = v;
        this.searchFiledNameByEquipment();
        // 上部表格
        this.searchEquipmentStatus()
        this.searchMonitorVerticalGraph();
      },
      goNext () {
        // this.$router.go(-1);
        // this.$router.push("/all/gaoyahuilu");
        this.$router.push({
          path: "/all/gaoyahuilu",
          query: {
            equipmentType: this.equipmentType
          },
        })
      },
      searchEquipmentByType () {
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post("bma-distribution-service/equipment/searchEquipmentByType", {
              equipmentTypeId: this.equipmentType,
              roomId: this.roomId,
            })
            .then((res) => {
              if (res.data.length > 0) {
                this.options = res.data;
                this.equipmentCode = res.data[0].equipmentCode;
                this.searchFiledNameByEquipment();
                // 上部表格
                this.searchMonitorVerticalGraph();
                // 左上角，设备数量统计统计
                this.searchEquipmentStatus();
                this.hasData = true;
              } else {
                this.hasData = false;
              }
            });
        }
      },
      searchFiledNameByEquipment () {
        this.$http
          .post(
            "bma-distribution-service/filedGroups/searchFiledNameByEquipment", {
            equipmentType: this.equipmentType,
            groupType: 2,
          }
          )
          .then((res) => {
            this.labelList = res.data;
            if (res.data.length > 0) {
              this.smallType = res.data[0].smallType;
              this.searchMonitorByEquipmentAndType();
            }
          });
      },
      searchMonitorByEquipmentAndType () {
        const projectId = this.$getCookie("projectId");
        this.hasData2 = true;
        this.$http
          .post(
            "bma-distribution-service/realTime/searchMonitorByEquipmentAndType", {
            chartDataType: this.smallType,
            date: this.date,
            equipmentCode: this.equipmentCode,
            projectId: projectId,
          }
          )
          .then((res) => {
            // 清空表格
            if (this.$refs.chart) {
              this.$refs.chart.clear();
            }
            let legend = [];
            let series = [];
            let maxLine = "";
            if (res.data) {
              if (res.data.length == 0) {
                this.hasData2 = false;
                return;
              }
              let allNum = []
              res.data.forEach((item, index) => {
                legend.push(item.subscribeFieldName);
                let arr = [];
                let Nums = [];

                // arr.push([
                //   this.$dateFormat("YYYY-mm-dd", new Date(this.date)) +
                //     " 00:00:00",
                //   "",
                // ]);
                item.dataList.forEach((j) => {
                  if (
                    j.date ===
                    this.$dateFormat("YYYY-mm-dd", new Date(this.date)) +
                    " 00:00:00" &&
                    j.value === ""
                  ) {
                    return false;
                  } else {
                    arr.push([j.date, this.$getTwo(j.value)]);
                    // console.log(index)
                    // if(j.value*1<0){
                    //   flag=true
                    // }else{
                    //   flag=false
                    // }
                    Nums.push(Math.abs(j.value));
                  }
                });
                allNum.push(Math.max(...Nums))
                // let dateEnd = new Date(this.date).getTime();
                // arr.push([
                //   this.$dateFormat("YYYY-mm-dd", new Date(dateEnd)) + " 23:00:00",
                //   "",
                // ]);
                let dateEnd = new Date(this.date).getTime() + 86400000;
                arr.push([
                  this.$dateFormat("YYYY-mm-dd", new Date(dateEnd)) + " 00:00:00",
                  "",
                ]);

                // console.log(parseInt(Math.max(...allNum) * 1.6))
                maxLine = this.smallType === 8 ? (Math.max(...allNum) * 2).toFixed(1) : (parseInt(Math.max(...allNum) * 2) === 0 ? parseInt(Math.max(...allNum)) : parseInt(Math.max(...allNum) * 2));
                console.log(maxLine)
                let obj = {
                  name: item.subscribeFieldName,
                  field: item.subscribeField,
                  type: this.smallType === 7 ? "bar" : "line",
                  symbolSize: 0,
                  lineStyle: this.smallType === 7 ?
                    "" : {
                      width: 4,
                    },
                  data: this.smallType === 7 ? arr.splice(0, 24) : arr,
                };
                series.push(obj);
              });
              this.option.legend.data = legend;
              let danwei

              switch (this.smallType) {
                case 2:
                  danwei = "A"
                  break;
                case 6:
                  danwei = "%"
                  break;
                case 5:
                  danwei = "%"
                  break;
                case 10:
                case 1:
                case 11:
                  danwei = "V"
                  break;
                case 3:
                  danwei = "kW"
                  break;
                case 4:
                  danwei = "kVar"
                  break;
                case 7:
                  danwei = "kWh"
                  break;
                case 12:
                  danwei = ""
                  break;
                case 8:
                  danwei = "%"
                  break;
                case 9:
                  danwei = "℃"
                  break;
              }

              this.option.tooltip.formatter = function (params) {
                const xname = params[0].value[0];
                let str = `${xname}<br>`;

                params.forEach((el, index) => {

                  str += `${el.marker}${el.seriesName}：${el.value[1]}${danwei}<br>`;
                });
                return str;
              }


              this.option.tooltip.axisPointer.type =
                this.smallType === 7 ? "none" : "line";
              (this.option.tooltip.axisPointer.label.formatter =
                this.smallType === 7 ?
                  function (p) {
                    if (p.axisIndex == 1) {
                      return "";
                    }
                    let str =
                      Number(p.seriesData[0].data[0].slice(10, 13)) + "时";
                    let str2 = "";
                    p.seriesData.forEach((i) => {
                      str2 + "<br/>" + i.seriesName + ": " + i.data[1];
                    });
                    return str + str2;
                  } :
                  function (p) {
                    if (p.axisIndex == 1) {
                      return "";
                    }
                    let str = p.seriesData[0].data[0];
                    let str2 = "";
                    p.seriesData.forEach((i) => {
                      str2 + "<br/>" + i.seriesName + ": " + i.data[1];
                    });
                    return str + str2;
                  }),
                (this.option.series = series);
              this.option.yAxis.max = maxLine;
            }
            if (this.$dateFormat("YYYY-mm-dd", new Date()) == this.date) {
              // this.setStomp(res.data);
            } else {
              this.topicList2.forEach((item) => {
                this.$clearTimeing(item);
              });
            }
          });
      },
      // setStomp(data) {
      //   const _this = this;
      //   if (data) {
      //     data.forEach((item) => {
      //       if (this.topicList2.indexOf(item.subscribeField + "a") == -1) {
      //         this.topicList2.push(item.subscribeField + "a");
      //       }
      //       if (this.topicList.indexOf(item.subscribeField + "a") == -1) {
      //         this.topicList.push(item.subscribeField + "a");
      //       }
      //       this.$timeing(
      //         item.subscribeField,
      //         item.subscribeField + "a",
      //         function (res) {
      //           let data = JSON.parse(res.body);
      //           _this.option.series.forEach((item) => {
      //             if (item.field == "/topic/app/TN001/" + data.field) {
      //               item.data.push([data.time, data.value]);
      //             }
      //           });
      //           _this.$refs.chart.mergeOptions(_this.option, true);
      //         }
      //       );
      //     });
      //   }
      // },
      filterblack (val) {
        if (val) {
          return val;
        } else {
          return "-";
        }
      },
      searchMonitorVerticalGraph () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post("bma-distribution-service/realTime/searchMonitorVerticalGraph", {
            equipmentCode: this.equipmentCode,
            projectId: projectId,
          })
          .then((res) => {
            this.ifShowTable = false;
            this.$nextTick(() => {
              this.ifShowTable = true;
              this.tableData[0].info[0] = this.getObjValue("12", res.data, "A");
              this.tableData[0].info[1] = this.getObjValue("13", res.data, "A");
              this.tableData[0].info[2] = this.getObjValue("14", res.data, "A");
              this.tableData[1].info[0] = this.getObjValue("01", res.data, "V");
              this.tableData[1].info[1] = this.getObjValue("02", res.data, "V");
              this.tableData[1].info[2] = this.getObjValue("03", res.data, "V");
              // this.tableData[2].info[0] = this.getObjValue("22", res.data, "kWh");
              // this.tableData[2].info[1] = this.getObjValue("18", res.data, "kWh");
              this.tableData[2].info[1] = this.getObjValue(
                "22",
                res.data,
                "kVar"
              );
              this.tableData[2].info[0] = this.getObjValue("18", res.data, "kW");
              this.tableData[3].info[0] = this.getObjValue("35", res.data, "kWh");
              this.tableData[3].info[1] = this.getObjValue(
                "loadRate",
                res.data,
                "%"
              );
              this.tableData[4].info[0] = this.getObjValue("A", res.data, "℃");
              this.tableData[4].info[1] = this.getObjValue("B", res.data, "℃");
              this.tableData[4].info[2] = this.getObjValue("C", res.data, "℃");
              this.tableData[5].info[0] = this.getObjValue(
                "openCloseTimes",
                res.data,
                "次"
              );
              this.tableData[5].info[0].subscribeFieldName = "已使用次数";
              this.tableData[6].info[0] = this.getObjValue("useDays", res.data);
              this.tableData[6].info[0].subscribeFieldName = "已使用时间";
              this.ifShowTable = true;
            });
            this.setStomp2(res.data);
          });
      },
      setStomp2 (data) {
        const _this = this;
        if (data) {
          data.forEach((item) => {
            if (this.topicList.indexOf(item.subscribeField) == -1) {
              this.topicList.push(item.subscribeField);
            }
            this.$timeing(
              item.subscribeField,
              item.subscribeField,
              function (res) {
                // alert(JSON.stringify(res.body))
                let data = JSON.parse(res.body);
                let getTime = data.time;
                _this.renewTime = getTime;
                _this.ifShowTable = false;
                _this.$nextTick(() => {
                  _this.tableData.forEach((i) => {
                    i.info.forEach((j) => {
                      if (j.subscribeField.indexOf(data.field) > -1) {
                        j.value = data.value;
                      }
                    });
                  });
                  _this.ifShowTable = true;
                });
              }
            );
          });
        }
      },
      searchMonitorTable () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/realTimeMonitoring/searchMonitorTable", {
            equipmentCode: this.equipmentCode,
            projectId: projectId,
            date: this.date,
          }
          )
          .then((res) => {
            // 12A电流 13B 14C  17三相电流不平衡率（百分比）
            // 1A 电压 2B 3C    35 三相总有功电度  6三相电压不平衡度
            // 22无用功率  18 有用功率 90/300 负载率
            // 07 AB线电压  08 BC线电压  09 CA线电压
            // 7 8 9 11  12 13 14 17 18 22  calculatePower
            let newData = res.data;
            let newArr = [];
            if (newData && newData.length > 0) {
              newData.forEach((item) => {
                let obj = {};
                for (let key in item.dataMap) {
                  // console.log(key + '---' + item.dataMap[key])
                  item.dataMap[key] = item.dataMap[key] ?
                    Math.floor(item.dataMap[key] * 100) / 100 :
                    "";
                }
                Object.assign(obj, item, item.dataMap);
                delete obj.dataMap;
                newArr.push(obj);
              });
              this.tableData1 = newArr;
            }
          });
      },
      download () {
        const projectId = this.$getCookie("projectId");
        this.$http({
          method: "post",
          url: "bma-distribution-service/realTimeMonitoring/exportMonitorTable",
          data: {
            equipmentCode: this.equipmentCode,
            projectId: projectId,
            date: this.date,
          },
          responseType: "blob",
        }).then((res) => {
          console.log(res);
          console.log(res.headers);
          let temp = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename=")[1];
          const data = res.data;
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let name = decodeURI(temp);
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      },
      // 设备数量及状态统计
      searchEquipmentStatus () {
        this.$http
          .post(
            "bma-distribution-service/realTimeMonitoring/searchEquipmentStatus", {
            equipmentCode: this.equipmentCode,
          }
          )
          .then((res) => {
            if (res.data) {
              this.equipmentNumber = res.data;
            }
          });
      },
      getObjValue (key, arr, unit) {
        let item = "";
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].field == key) {
            // if (key == "loadRate") {
            //   console.log("00000")
            //     console.log(arr[i]);
            //   item = this.$genderMenu(arr[i]*100);
            // } else {
            item = arr[i];
            break;
          }
        }
        if (item == "") {
          item = { "field": key, "subscribeField": "/" + this.equipmentCode + "/" + key, "subscribeFieldName": "", "unit": unit, "value": "0" }
          if (key == "12") {
            item.subscribeFieldName = "A 相电流"
          }
        }
        item.unit = unit ? unit : " ";
        return item;
      },
    },
    computed: {
      changeLabelList () {
        let arr = [];
        this.labelList.forEach((i) => {
          let obj = {
            label: i.groupName,
            smallType: i.smallType,
          };
          arr.push(obj);
        });
        return arr;
      },
      alarm () {
        return this.$store.state.alarmInfo;
      },
      roomId () {
        return this.$store.state.roomId;
      },
    },
    watch: {
      roomId () {
        this.topicList.forEach((item) => {
          this.$clearTimeing(item);
        });
        this.renewTime = ''
        this.searchEquipmentByType();
      },
      smallType (n, o) {
        if (!n) return;
        // 图表
        this.searchMonitorByEquipmentAndType();
        if (this.changeIndex == 1) {
          // 下部表格
          this.searchMonitorTable();
        }
      },
      date (n, o) {
        if (!n) return;
        if (!this.smallType) return;
        this.showTime = this.$dateFormat("YYYY年mm月dd日", new Date(n));
        // console.log(this.$dateFormat("YYYY年mm月dd日",new Date(n)))
        // 图表
        this.searchMonitorByEquipmentAndType();
        if (this.changeIndex == 1) {
          // 下部表格
          this.searchMonitorTable();
        }
      },
      changeIndex (n, o) {
        if (n == 1) {
          this.searchMonitorTable();
        }
      },
      alarm (n) {
        if (n.data.equipmentCode == this.equipmentCode) {
          this.equipmentNumber.equipmentStatus = 0;
        }
      },
    },
    beforeDestroy () {
      this.topicList.forEach((item) => {
        this.$clearTimeing(item);
      });
    },
  };
</script>

<style lang="less" scoped>
  .jinxian {
    background-color: #eceef3;

    .section1 {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;

      .item1 {
        // width: 333px;
        width: 20%;
        height: 518px;

        .box {
          padding-right: 26px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;

          >img {
            width: 90px;
          }

          .title {
            font-size: 24px;
            color: #293e69;
            margin-top: 27px;
            margin-bottom: 25px;
          }

          .el-select {
            width: 224px;
          }

          .switch,
          /deep/.el-input__inner {
            width: 224px;
            height: 42px;
            background: #3480ff;
            box-shadow: 0px 3px 6px rgba(20, 96, 224, 0.16);
            border-radius: 7px;
            padding: 0 18px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #fff;
            cursor: pointer;
          }

          .update-time {
            width: 244px;
            height: 30px;
            background: #f3f3f3;
            opacity: 1;
            border-radius: 5px;
            line-height: 30px;
            text-align: center;
            margin-top: 30px;
            margin-bottom: 20px;

            span {
              font-size: 14px;

              &:first-child {
                color: #94a1b4;
              }

              &:last-of-type {
                color: #1460e0;
              }
            }
          }

          .number {
            width: 223px;
            height: 41px;
            border: 1px solid #eaedef;
            border-radius: 21px;
            text-align: center;
            line-height: 41px;

            span {
              font-size: 14px;
              font-weight: 600;

              &:first-child {
                color: #0e223d;
              }

              &:last-of-type {
                color: #1460e0;
              }
            }
          }

          .bottom-box {
            width: 224px;
            margin-top: 30px;

            .top {
              display: flex;
              justify-content: space-between;

              >div {
                span {
                  font-size: 14px;
                  font-weight: 600;

                  &:first-child {
                    color: #0e223d;
                  }

                  &:last-of-type {
                    color: #1460e0;
                  }
                }
              }

              .right {
                span {
                  &:last-of-type {
                    color: #ff693b;
                  }
                }
              }
            }

            .middle {
              width: 100%;
              height: 8px;
              border-radius: 4px;
              overflow: hidden;
              display: flex;
              margin-top: 20px;
              margin-bottom: 24px;

              .left {
                width: 40%;
                height: 100%;
                background: #1460e0;
              }

              .among {
                width: 30%;
                height: 100%;
                background: #ff693b;
              }

              .right {
                width: 30%;
                height: 100%;
                background: #bebebe;
              }
            }

            .bottom {
              text-align: center;

              span {
                font-size: 14px;
                font-weight: 600;

                &:first-child {
                  color: #0e223d;
                }

                &:last-of-type {
                  color: #727272;
                }
              }
            }
          }
        }
      }

      .item2 {
        width: 79%; // width: 1297px;
        height: 518px;

        .box {
          padding-right: 45px;
          box-sizing: border-box;
          margin-top: 30px;

          /deep/.el-table {
            background: rgba(0, 0, 0, 0);

            th,
            tr {
              background: rgba(0, 0, 0, 0);
            }

            thead {
              background: #f5f5f5 !important;
            }

            th {
              >.cell {
                color: #152139;
                font-size: 14px;
                font-weight: 600;
                text-align: center;
              }
            }

            tr {
              td {
                text-align: center;
                font-size: 14px;
                color: #152139;
              }
            }

            .data-info {
              display: flex;
              justify-content: space-around;

              .item {
                span {
                  color: #152139;

                  &:last-of-type {
                    font-weight: 600;
                  }
                }
              }
            }
          }
        }
      }
    }

    .section2 {
      margin-top: 20px;
      padding-left: 10px;
      padding-bottom: 20px;

      .item1 {
        // width: 1640px;
        width: calc(100% - 10px);
        height: 640px;
        position: relative;

        .image-box {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 210px;
          left: 580px;

          img {
            width: 400px;
          }
        }

        .data-download {
          position: absolute;
          right: 20px;
          top: 15px;
          display: flex;
          font-size: 14px;

          img {
            margin-left: 30px;
            width: 40px;
            cursor: pointer;
          }
        }

        .swtich {
          height: 30px;
          margin-top: 30px;
          position: absolute;
          z-index: 20;

          .item {
            float: left;
            color: #0e223d;
            font-size: 14px;
            position: relative;
            margin-right: 20px;
            cursor: pointer;

            &.active {
              font-weight: 600;

              &::after {
                content: "";
                position: absolute;
                bottom: -14px;
                left: 0;
                right: 0;
                height: 3px;
                background: #1460e0;
              }
            }
          }
        }

        .change-box {
          display: flex;
          height: 30px;
          margin-top: 30px;
          position: absolute;
          top: 0;
          left: 180px;

          .item {
            width: 100px;
            height: 28px;
            border-radius: 16px;
            line-height: 28px;
            font-size: 14px;
            text-align: center;
            cursor: pointer;

            &.active {
              background: rgba(20, 96, 224, 0.1);
              color: rgba(20, 96, 224, 1);
            }
          }
        }

        .table {
          width: 100%;
          height: 550px;
          margin-top: 32px;
          border-top: 1px solid #eeeeef;
          position: relative;

          .table-box {
            padding-top: 60px;
            box-sizing: border-box;

            /deep/.el-table {
              background: rgba(0, 0, 0, 0);

              th,
              tr {
                background: rgba(0, 0, 0, 0);
              }

              thead {
                background: #f5f5f5 !important;
              }

              th {
                >.cell {
                  color: #152139;
                  font-size: 14px;
                  font-weight: 600;
                  text-align: center;
                }
              }

              tr {
                td {
                  text-align: center;
                  font-size: 14px;
                  color: #152139;
                }
              }
            }
          }
        }
      }
    }
  }

  .renew-time {
    float: right;
    margin-top: -45px;
  }

  .nodata {
    p {
      font-size: 24px;
      font-weight: 400;
      line-height: 41px;
      color: #6b7179;
      text-align: center;
    }

    img {
      width: 100%;
    }
  }
</style>